// Writes your routes here

// report-management (TEST)
// Service Type Api
// organization
export const organizationInformationReportApi = 'report-management/org-info-report/list'
export const circularPublicationReport = 'reportManagement/circular/publication/list'
export const circularApplicantReport = 'reportManagement/circular/applicant/list'
export const traineeAttendanceReport = 'reportManagement/trainee/list'
export const traineeProfileReportListApi = 'reportManagement/trainee/profile/list'
export const trainerProfileReportListApi = 'reportManagement/trainer/profile/list'

// trainee evaluation report apis
export const traineeEvaluationReportApi = 'report-management/trainee-evaluation-report/list'

// events-awards-report apis
export const eventsAwardsReportApi = 'report-management/events-awards-report/list'

// fiscal-year-calendar-report apis
export const fiscalYearReportApi = 'report-management/fiscal-year-calendar-report/list'

// trainer-honorarium-report apis
export const trainerHonorarimReportApi = 'report-management/trainer-honorarium-report/list'
export const trainerTaxReportApi = 'report-management/trainer-tax-report/list'
export const trainerApi = 'report-management/trainer-tax-report/trainer'

// training-material-report apis
export const trainingMaterialReportApi = 'report-management/training-material-report/list'

// trainer evaluation report apis
export const trainerEvaluationTrainerListApi = 'report-management/trainer-evaluation-report/get-trainers'
export const trainerEvaluationReportApi = 'report-management/trainer-evaluation-report/get-result'
export const traineeBatchListApi = 'report-management/trainee-batch-allowance/list'

// training summary report api
export const trainingSummaryReportApi = 'report-management/training-summary-report/list'
